import type { Translation } from "../types";

const ko: Translation = {
    // Navigation
    "nav.home": "홈",
    "nav.tools": "도구",
    "nav.minddeck": "MindDeck",
    "nav.jsonparser": "JSON Parser",
    "nav.guide": "가이드",
    "nav.about": "소개",
    "nav.contact": "연락처",
    "nav.faq": "FAQ",
    "nav.privacy": "개인정보보호",
    "nav.terms": "이용약관",
    "nav.changelog": "변경사항",
    "nav.roadmap": "로드맵",

    // Common
    "common.loading": "로딩 중...",
    "common.error": "오류가 발생했습니다",
    "common.back": "뒤로가기",
    "common.next": "다음",
    "common.previous": "이전",
    "common.search": "검색",
    "common.menu": "메뉴",
    "common.close": "닫기",
    "common.learnMore": "자세히 보기",

    // Home
    "home.title": "개발자와 학습자를 위한 도구",
    "home.subtitle": "효율적이고 직관적인 웹 기반 도구로 생산성을 높이세요",
    "home.tools.title": "제공 도구",
    "home.minddeck.title": "MindDeck",
    "home.minddeck.desc": "스마트한 플래시카드 학습 도구",
    "home.jsonparser.title": "JSON Diff Parser",
    "home.jsonparser.desc": "JSON 구조 비교 및 분석 도구",
    "home.features.title": "주요 특징",
    "home.features.performance.title": "빠른 성능",
    "home.features.performance.desc": "최적화된 웹 기술로 빠르고 효율적인 처리",
    "home.features.security.title": "안전한 사용",
    "home.features.security.desc": "클라이언트 사이드 처리로 데이터 보안 보장",
    "home.features.multilingual.title": "다국어 지원",
    "home.features.multilingual.desc": "한국어, 영어, 일본어, 중국어 지원",
    "home.cta.title": "지금 바로 시작하세요",
    "home.cta.subtitle": "무료로 제공되는 모든 도구를 활용해 보세요",
    "home.cta.minddeck": "MindDeck 시작하기",
    "home.cta.jsonparser": "JSON Parser 사용하기",
    "home.learnMore": "자세히 보기",

    // About
    "about.title": "MewSeeds 소개",
    "about.subtitle":
        "개발자와 학습자를 위한 혁신적인 웹 도구를 만드는 팀입니다",
    "about.stats.tools": "제공 도구",
    "about.stats.languages": "지원 언어",
    "about.stats.users": "사용자",
    "about.stats.uptime": "가동률",
    "about.mission.title": "우리의 미션",
    "about.mission.description":
        "복잡한 작업을 단순화하고, 개발자와 학습자들이 더 효율적으로 작업할 수 있도록 도구를 제공합니다. 사용자 경험을 최우선으로 하며, 지속적인 혁신을 통해 더 나은 솔루션을 만들어갑니다.",
    "about.values.title": "핵심 가치",
    "about.values.innovation.title": "혁신",
    "about.values.innovation.desc":
        "최신 기술을 활용하여 사용자에게 최고의 경험을 제공합니다.",
    "about.values.userFirst.title": "사용자 중심",
    "about.values.userFirst.desc":
        "사용자의 필요와 피드백을 바탕으로 제품을 개발합니다.",
    "about.values.privacy.title": "개인정보 보호",
    "about.values.privacy.desc":
        "사용자의 개인정보를 보호하고 안전한 서비스를 제공합니다.",
    "about.values.openSource.title": "오픈소스",
    "about.values.openSource.desc":
        "투명성과 협업을 통해 더 나은 도구를 만들어갑니다.",
    "about.techStack.title": "기술 스택",
    "about.contact.title": "연락하기",
    "about.contact.description":
        "문의사항이나 제안사항이 있으시면 언제든 연락해 주세요.",
    "about.contact.email": "이메일 보내기",
    "about.contact.github": "GitHub",

    // Footer
    "footer.copyright": "© 2025 MewSeeds. All rights reserved.",
    "footer.madeWith": "MewSeeds, 더 나은 세상을 위해",
    "footer.links": "바로가기",
    "footer.tools": "도구",
    "footer.support": "지원",
    "footer.contact": "연락처",
    "footer.goto.minddeck": "MindDeck 바로가기",
    "footer.goto.jsonparser": "JSON Parser 바로가기",

    // Guide
    "guide.title": "사용자 가이드",
    "guide.subtitle":
        "MewSeeds의 모든 도구를 효과적으로 활용하는 방법을 단계별로 안내합니다",
    "guide.minddeck.title": "MindDeck 사용 가이드",
    "guide.minddeck.desc":
        "플래시카드 기반 학습 도구 MindDeck의 모든 기능을 단계별로 알아보세요.",
    "guide.minddeck.step1": "계정 생성 및 로그인",
    "guide.minddeck.step2": "새로운 덱 생성하기",
    "guide.minddeck.step3": "카드 추가 및 편집",
    "guide.minddeck.step4": "학습 모드 시작하기",
    "guide.minddeck.step5": "진도 추적 및 통계 확인",
    "guide.jsonparser.title": "JSON Parser 활용법",
    "guide.jsonparser.desc":
        "JSON 데이터를 효율적으로 처리하고 변환하는 방법을 배워보세요.",
    "guide.jsonparser.step1": "JSON 데이터 입력하기",
    "guide.jsonparser.step2": "구문 검증 및 오류 확인",
    "guide.jsonparser.step3": "데이터 포맷 변환",
    "guide.jsonparser.step4": "필터링 및 정렬 기능",
    "guide.jsonparser.step5": "결과 내보내기",
    "guide.stepsTitle": "단계별 가이드",
    "guide.tipsTitle": "효과적인 학습을 위한 팁",
    "guide.tipsDesc": "더 나은 학습 경험을 위한 유용한 조언들",
    "guide.tip1.title": "정기적인 학습",
    "guide.tip1.desc":
        "매일 조금씩이라도 꾸준히 학습하는 것이 가장 효과적입니다.",
    "guide.tip2.title": "실습 중심 학습",
    "guide.tip2.desc": "이론만 공부하지 말고 실제로 도구를 사용해보세요.",
    "guide.tip3.title": "커뮤니티 활용",
    "guide.tip3.desc": "다른 사용자들과 경험을 공유하고 팁을 교환하세요.",
    "guide.tip4.title": "피드백 수집",
    "guide.tip4.desc": "사용 중 발견한 문제점이나 개선사항을 알려주세요.",
    "guide.ctaTitle": "지금 바로 시작해보세요",
    "guide.ctaDesc": "가이드를 따라하면서 실제로 도구들을 사용해보세요",
    "guide.cta.minddeck": "MindDeck 시작하기",
    "guide.cta.jsonparser": "JSON Parser 시작하기",
    "guide.modalTitle": "동영상 가이드 제작 중",
    "guide.modalDesc": "조금만 기다려 주세요!",

    // Tools
    "tools.subtitle": "개발과 학습에 도움이 되는 웹 기반 도구 모음",
    "tools.minddeck.desc":
        "스마트한 반복 학습 알고리즘을 통한 효율적인 암기 도구",
    "tools.minddeck.feature1": "반복 학습 알고리즘",
    "tools.minddeck.feature2": "진도 추적",
    "tools.minddeck.feature3": "다크모드 지원",
    "tools.minddeck.feature4": "모바일 최적화",
    "tools.jsonparser.desc":
        "JSON 데이터 구조를 시각적으로 비교하고 분석하는 도구",
    "tools.jsonparser.feature1": "실시간 비교",
    "tools.jsonparser.feature2": "차이점 시각화",
    "tools.jsonparser.feature3": "오류 검증",
    "tools.jsonparser.feature4": "클라이언트 사이드 처리",
    "tools.detail": "자세히 보기",
    "tools.useNow": "바로 사용하기",
    "tools.coming.title": "더 많은 도구가 준비 중입니다",
    "tools.coming.desc":
        "AI 번역기, 데이터 시각화 도구 등 유용한 도구들을 개발하고 있습니다.",
    "tools.roadmap": "로드맵 보기",

    // ToolMindDeck
    "minddeck.header.title": "MindDeck",
    "minddeck.header.desc1": "플래시카드 기반의 스마트 학습 도구",
    "minddeck.header.desc2": "효율적인 암기와 반복 학습을 누구나 쉽고 빠르게!",
    "minddeck.features.title": "주요 기능",
    "minddeck.features.1.title": "플래시카드 생성/관리",
    "minddeck.features.1.desc":
        "카드 추가, 편집, 삭제를 쉽고 빠르게 할 수 있습니다.",
    "minddeck.features.2.title": "스마트 반복 학습",
    "minddeck.features.2.desc":
        "Spaced Repetition 알고리즘으로 효율적 암기를 지원합니다.",
    "minddeck.features.3.title": "진도 추적 및 통계",
    "minddeck.features.3.desc":
        "학습 진도와 성취도를 시각적으로 확인할 수 있습니다.",
    "minddeck.features.4.title": "다국어/다크모드 지원",
    "minddeck.features.4.desc":
        "언제 어디서나 다양한 환경에서 학습할 수 있습니다.",
    "minddeck.steps.title": "사용 방법",
    "minddeck.steps.1":
        "플래시카드 추가를 이용하여 새로운 덱(Deck)을 생성하거나, 기존 덱을 불러오세요.",
    "minddeck.steps.2": "덱에 암기할 내용을 카드로 추가하세요.",
    "minddeck.steps.3": "학습 모드를 시작하여 플래시카드를 반복 학습하세요.",
    "minddeck.steps.4":
        "진도 및 통계를 확인하며 학습을 이어가세요. 덱 내에서 카드를 추가, 삭제, 편집할 수 있습니다.",
    "minddeck.usecases.title": "활용 예시",
    "minddeck.usecases.1": "영어 단어, 한자, 역사 연도 등 암기 과목 학습",
    "minddeck.usecases.2": "프로그래밍 문법, 용어, 알고리즘 암기",
    "minddeck.usecases.3": "자격증 시험 준비, 면접 대비",
    "minddeck.usecases.4":
        "업무 매뉴얼, 제품 정보 등 반복 학습이 필요한 모든 분야",
    "minddeck.faq.title": "자주 묻는 질문(FAQ)",
    "minddeck.faq.1.q": "모바일에서도 사용할 수 있나요?",
    "minddeck.faq.1.a":
        "네, MindDeck은 모바일과 데스크탑 모두에서 최적화되어 동작합니다. 모바일 크롬에서 오른쪽 상단의 점 세 개 메뉴를 누르고 '홈 화면에 추가' - '앱 설치'를 선택하면, 웹사이트를 앱처럼 사용할 수 있습니다",
    "minddeck.faq.2.q": "학습 데이터는 안전하게 저장되나요?",
    "minddeck.faq.2.a":
        "MindDeck은 어떠한 학습 데이터도 저장하지 않습니다. 모든 학습 데이터는 사용자의 브라우저에 저장됩니다.",
    "minddeck.faq.3.q": "무료로 사용할 수 있나요?",
    "minddeck.faq.3.a": "네, MindDeck은 누구나 무료로 사용할 수 있습니다.",
    "minddeck.cta": "MindDeck 바로가기",

    // ToolJsonParser
    "json.header.title": "JSON Parser",
    "json.header.desc1": "JSON 정렬, 비교, 뷰어 기능을 한 번에!",
    "json.header.desc2": "복잡한 JSON 데이터도 쉽고 빠르게 분석하세요.",
    "json.features.title": "주요 기능",
    "json.features.1.title": "JSON 정렬",
    "json.features.1.desc": "복잡한 JSON 데이터를 보기 쉽게 정렬해줍니다.",
    "json.features.2.title": "JSON 비교",
    "json.features.2.desc":
        "두 JSON 데이터의 차이점을 한눈에 비교할 수 있습니다.",
    "json.features.3.title": "JSON 뷰어",
    "json.features.3.desc":
        "트리 구조로 JSON을 쉽게 탐색하고 분석할 수 있습니다.",
    "json.steps.title": "사용 방법",
    "json.steps.1": "정렬, 비교, 뷰어 중 원하는 기능을 선택합니다.",
    "json.steps.2": "JSON 데이터를 입력합니다.",
    "json.steps.3": "결과를 확인하고, 필요하다면 복사 합니다.",
    "json.usecases.title": "활용 예시",
    "json.usecases.1": "API 응답 데이터 분석",
    "json.usecases.2": "버전별 JSON 구조 비교",
    "json.usecases.3": "복잡한 JSON 트리 시각화",
    "json.usecases.4": "데이터 변환 및 포맷팅",
    "json.faq.title": "자주 묻는 질문(FAQ)",
    "json.faq.1.q": "대용량 JSON도 처리할 수 있나요?",
    "json.faq.1.a":
        "네, 대부분의 대용량 JSON도 빠르게 처리할 수 있습니다. 단, 브라우저 메모리 한계에 따라 제한이 있을 수 있습니다.",
    "json.faq.2.q": "JSON 비교 결과를 저장할 수 있나요?",
    "json.faq.2.a": "네, 결과를 복사하거나 파일로 다운로드할 수 있습니다.",
    "json.faq.3.q": "모바일에서도 사용할 수 있나요?",
    "json.faq.3.a":
        "네, 모바일 환경에서도 최적화되어 동작합니다. 모바일 크롬에서 오른쪽 상단의 점 세 개 메뉴를 누르고 '홈 화면에 추가' - '앱 설치'를 선택하면, 웹사이트를 앱처럼 사용할 수 있습니다",
    "json.cta": "JSON Parser 바로가기",

    // Sidebar
    "sidebar.toolsOverview": "도구 소개",
    "sidebar.companyInfo": "회사 정보",

    // Privacy
    "privacy.title": "개인정보처리방침",
    "privacy.lastUpdate": "최종 업데이트: 2025년 7월 3일",
    "privacy.section1.title": "제1조 (목적)",
    "privacy.section1.content":
        '본 개인정보처리방침은 MewSeeds 및 MewSeeds에서 제공하는 모든 하위 서비스(이하 "서비스")를 운영하는 운영자(이하 "운영자")가 서비스 제공과 관련하여 수집·이용하는 이용자의 개인정보 처리 기준을 정함을 목적으로 합니다.',
    "privacy.section2.title": "제2조 (수집하는 개인정보 항목 및 방법)",
    "privacy.section2.content":
        "운영자는 서비스 운영 및 문의 응대 등을 위해 아래의 개인정보를 수집할 수 있습니다. 이메일 주소 (문의 시 수집), 사용자 피드백에 포함된 정보 (이름, 연락처 등 이용자가 자발적으로 입력한 내용). 운영자는 서비스 이용 시 자동으로 개인정보를 수집하지 않으며, 다만 맞춤형 광고 제공 등을 위해 쿠키 등 식별정보가 수집될 수 있습니다. 쿠키 수집 여부는 이용자가 브라우저 설정을 통해 거부할 수 있습니다.",
    "privacy.section3.title": "제3조 (개인정보의 이용 목적)",
    "privacy.section3.content":
        "운영자는 수집한 개인정보를 아래의 목적으로만 이용합니다. 이용자의 문의 응답 및 처리, 법령상 의무 준수 및 분쟁 대응, 맞춤형 광고 제공(동의한 경우)",
    "privacy.section4.title": "제4조 (개인정보 보유 및 이용 기간)",
    "privacy.section4.content":
        "수집된 개인정보는 문의 처리 완료 후 일정 기간 보관할 수 있으며, 이후 지체 없이 파기합니다. 다만, 법령에 따라 일정 기간 보존해야 하는 경우에는 해당 법령에서 정한 기간 동안 보관할 수 있습니다. 전자상거래법에 따른 거래 기록: 5년, 통신비밀보호법에 따른 접속 기록: 3개월 등",
    "privacy.section5.title": "제5조 (개인정보 제3자 제공)",
    "privacy.section5.content":
        "운영자는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외적으로 제공될 수 있습니다. 이용자가 사전에 동의한 경우, 법령에 따라 제공이 요구되는 경우",
    "privacy.section6.title": "제6조 (개인정보 보호책임자)",
    "privacy.section6.content": "이름: MewSeeds, 이메일: mewseeds@gmail.com",
    "privacy.section7.title": "제7조 (권리와 행사 방법)",
    "privacy.section7.content":
        "이용자는 언제든지 운영자에게 개인정보 열람, 정정, 삭제, 처리정지 등을 요구할 수 있으며, 운영자는 법령에 따라 신속히 조치합니다.",
    "privacy.section8.title": "제8조 (개인정보 처리방침 변경)",
    "privacy.section8.content":
        "본 방침은 2025년 7월 3일부터 적용됩니다. 운영자는 본 방침을 변경할 경우 변경사항을 시행 최소 7일 전, 중요사항은 30일 전 공지합니다.",

    // Terms
    "terms.title": "MewSeeds 이용약관",
    "terms.lastUpdate": "최종 업데이트: 2025년 7월 3일",
    "terms.section1.title": "제1조 (목적)",
    "terms.section1.content":
        '본 개인정보처리방침은 MewSeeds 및 MewSeeds에서 제공하는 모든 하위 서비스(이하 "서비스")를 운영하는 운영자(이하 "운영자")가 서비스 제공과 관련하여 수집·이용하는 이용자의 개인정보 처리 기준을 정함을 목적으로 합니다.',
    "terms.section2.title": "제2조 (서비스 이용)",
    "terms.section2.content":
        "이용자는 서비스를 자유롭게 이용할 수 있습니다. 이용자는 서비스 이용 시 관련 법령과 본 약관을 준수해야 하며, 다른 이용자의 서비스 이용을 방해하거나 서비스의 정상적인 운영을 방해해서는 안 됩니다. 이용자는 운영자의 사전 서면 동의 없이, 서비스에서 제공된 자료, 정보, 콘텐츠를 상업적으로 이용하거나 복제, 배포, 전송, 공개, 2차적 저작물 작성 등을 해서는 안 됩니다. 이용자는 운영자의 명칭(MewSeeds 등), 로고, 상표 등을 사칭하거나 무단으로 사용해서는 안 됩니다.",
    "terms.section3.title": "제3조 (지식재산권)",
    "terms.section3.content":
        "MewSeeds의 명칭, 로고, 디자인, 프로그램, 데이터베이스, UI/UX 등 서비스와 관련된 지식재산권은 운영자에게 있습니다. 이용자가 본 약관을 위반하여 운영자의 지식재산권을 침해한 경우, 운영자는 민사 및 형사상 법적 조치를 취할 수 있으며, 이로 인해 발생한 손해를 청구할 수 있습니다.",
    "terms.section4.title": "제4조 (광고)",
    "terms.section4.content":
        "운영자는 서비스 화면 등에 광고를 게재할 수 있습니다. 이용자는 서비스 이용 시 광고가 노출될 수 있음을 인정합니다. 운영자는 서비스의 운영과 무상 제공을 위해 광고를 게재하며, 이를 통해 수익을 창출할 수 있습니다. 이용자가 광고를 통해 참여하거나 거래한 결과로 발생한 손해에 대해 운영자는 책임을 지지 않습니다. 맞춤형 광고 제공 시 필요한 정보 수집·이용은 개인정보처리방침에 따릅니다.",
    "terms.section5.title": "제5조 (면책조항)",
    "terms.section5.content":
        "운영자는 천재지변, 시스템 장애, 서버 과부하, 해킹, 통신 장애 등 불가항력적 사유로 서비스를 제공하지 못할 경우 책임을 지지 않습니다. 운영자는 이용자가 서비스를 통해 얻은 정보나 자료의 정확성, 완전성, 유용성에 대해 보증하지 않으며, 이를 신뢰하거나 이용해 발생한 손해에 대해 책임을 지지 않습니다. 운영자는 무료로 제공되는 서비스에 대해 관련 법령에 특별한 규정이 없는 한 손해배상 책임을 지지 않습니다.",
    "terms.section6.title": "제6조 (분쟁해결 및 관할)",
    "terms.section6.content":
        "운영자와 이용자는 서비스 이용과 관련하여 분쟁이 발생할 경우 성실히 협의하여 해결합니다. 협의로 해결되지 않는 경우, 「콘텐츠산업 진흥법」, 「전자상거래 등에서의 소비자보호에 관한 법률」 등에 따른 분쟁조정기관에 분쟁조정을 신청할 수 있습니다. 분쟁조정으로도 해결되지 않거나 조정을 원하지 않는 경우, 소송은 운영자의 주소지를 관할하는 법원으로 합니다.",
    "terms.section7.title": "제7조 (부칙)",
    "terms.section7.content": "본 약관은 2025년 7월 3일부터 시행합니다.",

    // Contact
    "contact.title": "연락처",
    "contact.subtitle":
        "궁금한 점이나 제안사항이 있으시면 언제든지 연락해 주세요",
    "contact.infoTitle": "연락처 정보",
    "contact.emailTitle": "이메일",
    "contact.emailDesc": "일반적인 문의사항이나 제안사항",
    "contact.siteTitle": "사이트",
    "contact.siteDesc": "메인 웹사이트",
    "contact.timeTitle": "응답 시간",
    "contact.timeValue": "24시간 이내",
    "contact.timeDesc": "평일 기준 빠른 응답",
    "contact.faqTitle": "자주 묻는 질문",
    "contact.faq1.q": "서비스는 무료인가요?",
    "contact.faq1.a": "네, 모든 도구는 무료로 제공됩니다.",
    "contact.faq2.q": "기능 제안은 어떻게 하나요?",
    "contact.faq2.a": "이메일로 제안사항을 보내주시면 검토 후 반영하겠습니다.",
    "contact.faq3.q": "버그 신고는 어디서 하나요?",
    "contact.faq3.a":
        "이메일로 버그 내용을 자세히 설명해 주시면 빠르게 수정하겠습니다.",
};

export default ko;
